/* eslint-disable react/no-array-index-key */
import React from 'react';
import ImageSplash from './ImageSplash';
import PictogramSplash from './PictogramSplash';
import RoundSplash from './RoundSplash';
import type { ISplash } from './shared/types';
import TagSplash from './TagSplash';

export default function SplashRenderer({ splash, ...restProps }: { splash: ISplash }): JSX.Element {
    const { displayType, type } = splash;

    switch (displayType) {
        case 'Image':
            if (type === 'Hazard') return <PictogramSplash {...splash} {...restProps} />;
            return <ImageSplash {...splash} {...restProps} />;
        case 'Label':
            return <TagSplash {...splash} {...restProps} />;
        case 'Round':
            return <RoundSplash {...splash} {...restProps} />;
        default:
            console.warn(`${displayType} is not reconized as a valid SplashRenderer type`);
            return <></>;
    }
}
